import './preprocessSpiral';
import { memo, useCallback, useRef } from 'react';
import { useAsset } from '@artica/assets';
import { useIsBetween } from '@immutabl3/alchemy';
import { parallax } from '@immutabl3/alchemy/three';
import spiralAnim from './spiral.animation.json';
import { spriteSpiral } from '../../common/formatSpiral';

const SPIN_RATES = [0.003, 0.005, 0.002];

const onAnimation = (group, { animatables }) => {
  const [{ target: { opacity } }] = animatables;
  group.traverse(child => {
    if (!child?.material) return;
    child.material.opacity = opacity;
  });
};

const Spiral = memo(function({ visible }) {
  const spiral = useAsset('spiral');
  const { spriteMat } = spiral;
  const dotSprite = spriteMat.map = useAsset('dot_sprite');

  spriteSpiral(spiral, dotSprite, [
    { count: 200, scale: 0.5, offset: { x: 0, y: 0, z: -0.1 }, genOffset: -0.5, slide: 0, transparent: true },
    { count: 1, scale: 0.5, offset: { x: 0, y: 0, z: 0 }, genOffset: 0, slide: 0, transparent: true },
    { count: 100, scale: 0.5, offset: { x: 0, y: -0.1, z: 0 }, genOffset: 0, slide: 0.05, transparent: true },
  ]);

  const ref = useRef();

  const onTick = useCallback((_, ref) => {
    const obj = ref.current;
    if (!obj) return;

    const rotY = obj.rotation.y + 0.003 / Math.PI;
    obj.rotation.y = rotY;

    for (let i = 0; i < obj.children.length; i++) {
      const group = obj.children[i];
      const rate = SPIN_RATES[i];
      const rotY = group.rotation.y + rate / Math.PI;
      group.rotation.y = rotY;
    }
  }, []);

  return (
    <parallax.primitive
      ref={ ref }
      object={ spiral }
      beaker="chapter1"
      animation={ spiralAnim }
      onTick={ onTick }
      visible={ visible }
      onAnimation={ onAnimation }
    />
  );
});

export default function SpiralContainer() {
  // NOTE: this is more performant on mobile
  // with the useIsBetween hook and react's memo
  // toggling visibility because the spiral asset
  // is a group/scene with children, not a mesh
  // primitive. the mounting/unmounting causes
  // more jank than the visibility toggle
  const visible = useIsBetween(
    'chapter1',
    spiralAnim[0].timestamp,
    spiralAnim[1].timestamp + spiralAnim[1].duration,
  );
  return <Spiral visible={ visible } />;
};
